var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.832,
    height: 29.104,
    viewBox: "0 0 19.832 29.104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g2234",
    transform: "translate(873.959 434.661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect989-9",
    d: "M-872.254-414.187h16.422a.951.951,0,0,1,.955.951v22.607a.951.951,0,0,1-.955.952h-16.422a.951.951,0,0,1-.955-.952v-22.607A.951.951,0,0,1-872.254-414.187Z",
    transform: "translate(0 -16.629)",
    fill: "none",
    stroke: "#aa0100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 6.2,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1131",
    d: "M-872.764-428.6h18.249",
    transform: "translate(-0.376 -4.475)",
    fill: "none",
    stroke: "#aa0100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1133",
    d: "M-847.834-394.011v18.179",
    transform: "translate(-21.394 -33.64)",
    fill: "none",
    stroke: "#aa0100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1135",
    d: "M-814.784-394.011v18.179",
    transform: "translate(-49.259 -33.64)",
    fill: "none",
    stroke: "#aa0100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1137",
    d: "M-781.734-394.011v18.179",
    transform: "translate(-77.124 -33.64)",
    fill: "none",
    stroke: "#aa0100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1139",
    d: "M-831.685-433.911h5.359",
    transform: "translate(-35.009)",
    fill: "none",
    stroke: "#aa0100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon_delete.e0684b63341f067703de09d8b03980bc.svg";
export { ForwardRef as ReactComponent };